/*
  GA — product card image swipe (touch only)
  -------------------------------------------
  Desktop already swaps the card's primary/secondary photo on :hover
  (see ga-product-card.css, scoped to `(hover: hover) and (pointer: fine)`
  so it never fires on touch). Touch devices have no hover, so that second
  photo was never reachable on mobile. This adds the touch equivalent: a
  left/right swipe (or a plain tap) on the card image toggles a class that
  the same CSS file listens for, without adding any visible arrows.

  No mouse/desktop behavior is touched — this only binds touch listeners,
  so pointer:fine devices are completely unaffected.
*/
(function () {
  var SWIPE_THRESHOLD = 24; // px of horizontal movement to count as a swipe, not a tap-scroll

  function initCard(link) {
    if (link.dataset.gaSwipeBound) return;
    link.dataset.gaSwipeBound = 'true';

    var startX = 0;
    var startY = 0;
    var tracking = false;

    link.addEventListener(
      'touchstart',
      function (event) {
        if (!event.touches || event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        tracking = true;
      },
      { passive: true }
    );

    link.addEventListener(
      'touchend',
      function (event) {
        if (!tracking) return;
        tracking = false;
        var touch = event.changedTouches && event.changedTouches[0];
        if (!touch) return;

        var deltaX = touch.clientX - startX;
        var deltaY = touch.clientY - startY;

        // Ignore mostly-vertical touches so scrolling the page isn't hijacked.
        if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) < Math.abs(deltaY)) return;

        event.preventDefault();
        link.classList.toggle('ga-products__image-link--flipped');
      },
      { passive: false }
    );
  }

  function initAll() {
    document.querySelectorAll('.ga-products__image-link').forEach(initCard);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  // Re-scan after Shopify section reloads / infinite-scroll style re-renders,
  // same pattern used by the theme's other card-level scripts.
  document.addEventListener('shopify:section:load', initAll);
})();
